import React from 'react'
import { Link } from 'gatsby'
import './index.scss'
import { useTranslation } from 'react-i18next'

interface LogoProps {
  hideSubtitle?: boolean
}

export default function Logo(props: LogoProps) {
  const { hideSubtitle = false } = props
  const showSubtitle = !hideSubtitle
  const { t } = useTranslation()

  return (
    <Link className="Logo" to="/">
      <img src={`/images/light/deque.png`} alt="Deque" />
      {showSubtitle && <span className="Logo__subtitle">{t('docs')}</span>}
    </Link>
  )
}
